import React, { Component } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import '../css/Home.css';
import { Icon } from 'react-materialize'
import { connect } from 'react-redux'
import { data } from '../js/data.js';
import { changeLanguage } from '../js/actions/changeLanguage'


const languages = [];


class LanguageSelect extends Component {

    handleClose = () => {
      this.props.onClose(this.props.selectedValue);
    };
  
    handleListItemClick = (value) => {
      var language = value;
      this.props.onClose(value);
        this.props.changeLanguage(language);
    };

    componentDidMount(){
      var languageList = data;
      if(languages.length==0){
        for(var i in languageList){
          languages.push(i)
        }
      }
    }
  
    render() {
      const { classes, onClose, selectedValue, ...other } = this.props;
      return (
        <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
          <DialogTitle id="simple-dialog-title">Select Language <Icon className='tiny'>language</Icon></DialogTitle>
          <div>
            <List>
            {languages.map(language => (
              <ListItem button onClick={() => this.handleListItemClick(language)} key={language}>
                <ListItemText primary={language} />
              </ListItem>
            ))}
            </List>
          </div>
        </Dialog>
      );
    }
}

const mapStateToProps = (state) => {
  return{
      languages: state.language.language
  }
}

const mapDispatchToProps = (dispatch) =>{
  return{
    changeLanguage: (language) => dispatch(changeLanguage(language))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);
